/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var PureRenderMixin, React, ReactDOM, css;

React = require('react');

ReactDOM = require('react-dom');

PureRenderMixin = require('react-addons-pure-render-mixin');

css = require('../css/menu.styl');

module.exports = React.createClass({
  mixins: [PureRenderMixin],
  displayName: 'Menu',
  logout: function() {
    if (!confirm('Určitě se chete odhlásit?')) {
      return;
    }
    return this.props.actions.logout();
  },
  leaveGame: function() {
    var id;
    if (!confirm('Určitě chcete opustit hru?')) {
      return;
    }
    if (!(id = this.props.user.gameId)) {
      return;
    }
    this.props.actions.leaveGame(id);
  },
  renderLeaveGameBtn: function() {
    if (!this.props.user.gameId) {
      return null;
    }
    return React.createElement("div", {
      "className": "btn btn-primary",
      "onClick": this.leaveGame
    }, "Opustit hru");
  },
  renderLogoutBtn: function() {
    if (!this.props.user.data.id) {
      return null;
    }
    return React.createElement("div", {
      "className": "btn btn-primary",
      "onClick": this.logout
    }, "Odhlásit se");
  },
  render: function() {
    return React.createElement("nav", {
      "className": css['menu']
    }, this.renderLeaveGameBtn(), this.renderLogoutBtn());
  }
});


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "menu.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/menu.cjsx
 ** module id = 274
 ** module chunks = 0
 **/